"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = void 0;
exports.path = '/api-info';
//# sourceMappingURL=index.js.map